// extracted by mini-css-extract-plugin
module.exports = {"ImageGrid":"ComponentBodyPhotoGallery_ImageGrid__VLTsT","Image":"ComponentBodyPhotoGallery_Image__RCuAC","Header":"ComponentBodyPhotoGallery_Header__8fsuF"};